export const KneeTraumaticText = {
  values: [
    { value: 'KneeTraumatic', text: 'Ja', score: 1 },
    { value: 'KneeTraumatic', text: 'Nei', score: 0 },
    { value: 'KneeTraumatic', text: 'Ikke aktuelt', score: -1 },
  ],
};
